import React, { useEffect, useState } from 'react'
import { makeStyles, createStyles, Box, CircularProgress } from '@material-ui/core/'
import Countdown from 'react-countdown'
import { useTranslation } from 'react-i18next'
import getTime from 'date-fns/getTime'
import { GET_CODE_EXPIRED_TIME } from 'src/utils/constant'
import { getStore, setStore } from 'src/utils/auth'
import { API } from 'src/store/api'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexShrink: 0,
      color: theme.palette.secondary.main,
      backgroundColor: '#FEEEEA',
      textAlign: 'center',
      maxWidth: theme.spacing(18),
      marginBottom: theme.spacing(2),
      fontWeight: 600,
    },
    root2: {
      flexShrink: 0,
      color: theme.palette.grey[400],
      backgroundColor: '#e0e0e0',
      textAlign: 'center',
      maxWidth: theme.spacing(18.5),
      marginBottom: theme.spacing(2),
      fontWeight: 600,
    },
  }),
)

const CodeButton = (props) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const [timestamp, setTimestamp] = useState(0)
  const [status, setStatus] = useState('')

  useEffect(() => {
    setTimestamp(getStore(`${props.type}_${props.action}`) || 0)
  }, [props.type, props.action])

  const _handleGetCode = async (params) => {
    if (status === 'pending') return
    try {
      setStatus('pending')
      props.onBeforeGetCode && (await props.onBeforeGetCode())
      if (props.type === 'email') {
        await API.getCode(props.params)
      } else {
        await API.getPhoneCode(props.params)
      }
      const newTimestamp = getTime(new Date())
      setStore(`${props.type}_${props.action}`, newTimestamp)
      setTimestamp(newTimestamp)
      setStatus('fulfilled')
    } catch (error) {
      props.onGetCodeError && props.onGetCodeError()
      setStatus('rejected')
    }
  }

  return (
    <Countdown
      key={timestamp}
      date={timestamp + GET_CODE_EXPIRED_TIME}
      renderer={({ seconds, minutes, completed }) => {
        if (completed) {
          return (
            <Box className={classes.root} onClick={_handleGetCode} px={2} py={1}>
              {status === 'pending' ? <CircularProgress color="inherit" size={24} /> : t('form.get_v_code')}
            </Box>
          )
        } else {
          return (
            <Box px={2} py={1} className={classes.root2} color="grey.800">
              {t('glossary.get_code_again')}
              {minutes * 60 + seconds}s
              {/* {`0${minutes}`.slice(-2)}
              {t('common.minute')}
              {`0${seconds}`.slice(-2)}
              {t('common.second')} */}
            </Box>
          )
        }
      }}
    />
  )
}

export default CodeButton
